import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { requestMobileMoneyBalance } from "./mobileMoneyBalance.request";
import { MobileMoneyBalanceResponse } from "./mobileMoneyBalance.types";

const useMobileMoneyBalance = (
  options?: QueryOptions<MobileMoneyBalanceResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["mobile-money-balance"],
    queryFn: requestMobileMoneyBalance,
    ...options
  });

  return { balance: data?.amount, currency: data?.currency, ...rest };
};

export default useMobileMoneyBalance;
